import { calculateAndFormatLeadTimeWeeks } from '@lib/calculations/lead-time';
import { Text, View } from '@react-pdf/renderer';
import { LeadTimeFormat } from '@snap-types/schemas/lead-time-format';
import { Nullish } from '@snap-types/types/nullish';

import { styles } from '../styles';

type QuoteLineDetailsProps = {
  drawingId: Nullish<string>;
  drawingRevision: Nullish<string>;
  leadTime: Nullish<number>;
  leadTimeNotes: Nullish<string>;
  leadTimeFormat: Nullish<LeadTimeFormat>;
  showDrawing: boolean;
};

function generateLeadTimeText(
  leadTime: Nullish<number>,
  leadTimeNotes: Nullish<string>,
  leadTimeFormat: LeadTimeFormat,
) {
  if (leadTimeFormat === LeadTimeFormat.TEXT) {
    return leadTimeNotes;
  }

  const leadTimeWeeks = calculateAndFormatLeadTimeWeeks(leadTime ?? 0);

  if (leadTimeFormat === LeadTimeFormat.BOTH) {
    return `${leadTimeWeeks} (${leadTimeNotes})`;
  }

  return `${leadTimeWeeks}`;
}

export function QuoteLineDetails({
  drawingId,
  drawingRevision,
  leadTime,
  leadTimeNotes,
  leadTimeFormat,
  showDrawing,
}: QuoteLineDetailsProps) {
  const leadTimeText = generateLeadTimeText(
    leadTime,
    leadTimeNotes,
    leadTimeFormat ?? LeadTimeFormat.NUMBER,
  );

  return (
    <View style={{ minWidth: '110pt' }}>
      {showDrawing && drawingId ? (
        <View style={[styles.gap10, styles.row, styles.justifyBetween]}>
          <Text>DWG ID</Text>
          <Text>{drawingId}</Text>
        </View>
      ) : null}

      {showDrawing && drawingRevision ? (
        <View style={[styles.gap10, styles.row, styles.justifyBetween]}>
          <Text>Revision No</Text>
          <Text>{drawingRevision}</Text>
        </View>
      ) : null}

      {leadTimeText ? (
        <View style={[styles.gap10, styles.row, styles.justifyBetween]}>
          <Text>Lead Time</Text>
          <Text>{leadTimeText}</Text>
        </View>
      ) : null}
    </View>
  );
}
